import styled from 'styled-components'
import Button from 'antd/lib/button'
import Caroussel from 'react-slick'
import {
  BLACK,
  WHITE,
  GRAY_LIGHTEST,
  GRAY_LIGHT,
  BLUE
} from '../../theme/colors'

interface DivProps {
  secondary?: boolean
  third?: boolean
}

export const Container = styled.div`
  justify-content: center;
  display: flex;
  width: 100%;
  padding-bottom: 34px;
  position: relative;
  margin-bottom: ${({ secondary }: DivProps) => secondary ? '22px' : 'unset'};
  animation: fade-in-top 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-top {
    0% {
      transform: translateY(-10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @media (max-width: 698px) {
    flex-wrap: wrap;
    padding: 0 20px;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background: ${WHITE};
  width: 340px;
  margin-left: 30px;
  transition: all 0.25s;
  cursor: pointer;
  &:hover {
    box-shadow: 0 3px 11px 1px rgba(0, 0, 0, 0.15);
  }
  &:first-child {
    margin-left: 0px;
  }
  border: 1px solid ${GRAY_LIGHT};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  position: relative;
  @media (max-width: 1280px) {
    width: 268px;
  }
  @media (max-width: 768px) {
    width: auto;
    flex: 1;
  }
  @media (max-width: 698px) {
    margin-left: 0px;
    margin-top: 42px;
    &:first-child {
      margin-top: 0px;
    }
  }
  ${({ secondary, third }: DivProps) => secondary ? `
    cursor: auto;
    box-shadow: unset;
    &:hover {
      box-shadow: unset;
    }
    @media (max-width: 698px) {
      &:first-child {
        margin-left: ${third ? '0px' : '30px'};
      }
    }
  ` : ''}
`

export const CardTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
  color: ${BLACK};
  background: ${GRAY_LIGHTEST};
  text-align: center;
  padding: 8px;
`

export const TeamBanner = styled.img`
  max-width: 160px;
  width: 100%;
  margin-bottom: 4px;
`

export const TeamImage = styled.img`
  width: 100%;
  object-fit: cover;
  margin-bottom: 20px;
  height: 154px;
  @media (max-width: 1280px) {
    height: 114px;
  }
  @media (max-width: 698px) {
    height: 100px;
  }
`

export const TeamImageFixed = styled.img`
  width: 100%;
  object-fit: contain;
  margin-bottom: 20px;
  height: 154px;
  padding: 22px;
  background: #f1f4f5;
  @media (max-width: 1280px) {
    height: 114px;
  }
  @media (max-width: 698px) {
    height: 100px;
    padding: 12px;
  }
`

export const List = styled.ul`
  padding: 0;
  margin: 0 28px;
  list-style: none;
  text-align: center;
  line-height: 1.1;
  font-size: 12.5px;
  @media (max-width: 1280px) {
    font-size: 11px;
  }
  @media (max-width: 698px) {
    line-height: 1;
  }
`

export const Item = styled.li`
  margin-bottom: 10px;
`

export const BottomSection = styled.div`
  flex: 1;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 12px;
  margin-bottom: 24px;
`

export const BottomImage = styled.img`
  max-width: 220px;
`

export const SelectTeamStoreButton = styled(Button)`
  height: 40px;
  border: 2px solid ${BLUE};
  border-radius: 2px;
  background-color: ${WHITE};
  color: ${BLUE};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
  text-align: center;
  width: 200px;
  margin: 0 auto;
  margin-bottom: 28px;
`

export const CardBadge = styled.img`
  max-width: 96px;
  position: absolute;
  left: calc(50% - 48px);
  top: -20px;
  box-shadow: 0px -1px 3px -1px #a3a3a3;
  border-radius: 3px;
`

export const AskManager = styled.div`
  position: absolute;
  bottom: 0px;
  left: 50%;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-family: Avenir;
  @media (max-width: 698px) {
    display: none;
  }
`

export const LeftArrow = styled.img`
  max-width: 22px;
  transform: rotate(90deg);
  margin-top: -20px;
  margin-right: 8px;
`

export const RightArrow = styled.img`
  max-width: 22px;
  transform: scaleX(-1) rotate(90deg);
  margin-top: -20px;
  margin-left: 8px;
`

export const CarousselDiv = styled(Caroussel)`
  max-width: 100%;
  .slick-slide {
    padding-top: 22px;
  }
  & .slick-prev {
    z-index: 2;
    margin-left: 30px;
  }
  & .slick-next {
    z-index: 2;
    left: calc(100vw - 46px);
    right: unset !important;
  }
  .slick-slide img {
    display: unset !important;
  }
`

export const Arrow = styled.img``



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TeamStoreCards/styledComponents.tsx